// extracted by mini-css-extract-plugin
export var inputContainer = "_nr-0";